
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq7anrwWWAgGs3tXTCoJMGgajwAWpYuwSPW18WdF0jfncMeta } from "/codebuild/output/src1270943608/src/src/pages/faq.vue?macro=true";
import { default as menu5PkTmMp7FpAGgdbJ0ef4gHTnQIUzgqOBRZO1wauSqSYMeta } from "/codebuild/output/src1270943608/src/src/pages/menu.vue?macro=true";
import { default as index_Qri7I9UT8XwvXZx5n_xFIwbqoe0J9Ta59nqpZEfSUkMeta } from "/codebuild/output/src1270943608/src/src/pages/index.vue?macro=true";
import { default as contactpopFYAiDMie2vrVjcVWb1kC8bYe94HN_KlL4yA5vKTEMeta } from "/codebuild/output/src1270943608/src/src/pages/contact.vue?macro=true";
import { default as tutorialuRqyG9GCLKxE39Mms9qKOnFJfBEA2uFm9PnEGzXZn2MMeta } from "/codebuild/output/src1270943608/src/src/pages/tutorial.vue?macro=true";
import { default as agreementEgO1b1kMO1oCOCFxjDGIrid46fqK_45UKnnVfw9EI7TpgMeta } from "/codebuild/output/src1270943608/src/src/pages/agreement.vue?macro=true";
import { default as about_45passpCuyJPc_BSlZLFHcTB6KUgS33GN32bgiVm5V9DvCKhMMeta } from "/codebuild/output/src1270943608/src/src/pages/about-pass.vue?macro=true";
import { default as indexBECQoMD657lV2v_DEAclKof6mhRxcM0RVyEOuLVqcNYMeta } from "/codebuild/output/src1270943608/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93fpIPM50jls0np6MLVpRg7quYJ_45sG26QB9VzdZkOTDeAMeta } from "/codebuild/output/src1270943608/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancewE8I_45jt6HaIBib6KFKscbx1Yma5N8CXhi1_RvZVJIw0Meta } from "/codebuild/output/src1270943608/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93LOMqvqyXWxHBjGoPWXrnDu7efQMyu1PNXbGfrwgko94Meta } from "/codebuild/output/src1270943608/src/src/pages/notice/[id].vue?macro=true";
import { default as indexNEwFUca9HO_kLCHqMFD_sxsBazHGXf_45GEd5CyddDdaUMeta } from "/codebuild/output/src1270943608/src/src/pages/coupon/index.vue?macro=true";
import { default as indexudMhOH6yVws8HliohTDhtviaYuKUgUx0N2ofoFxk84oMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/index.vue?macro=true";
import { default as index_7i5xaye0qdGRDVhoSOuK6PjRMZZa_JjglaNyKHLKQsMeta } from "/codebuild/output/src1270943608/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93otZ1oxsPm0BMv08N5nHQKHiRzUvSkI60sRUxi0WfujsMeta } from "/codebuild/output/src1270943608/src/src/pages/parking/[id].vue?macro=true";
import { default as index3ggf5JO2W2DY6fFmPKhfISxQApoojL6ZRDDQgpW8w7kMeta } from "/codebuild/output/src1270943608/src/src/pages/history/index.vue?macro=true";
import { default as indexkznan6V2gHPSiHx5JHBp7Xh46M5yiaKTHMYpChZ76QIMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/index.vue?macro=true";
import { default as indexgOHDXmkILJAzA8Mks8Tf_COhr5z6mXneWn7dq7u4rtAMeta } from "/codebuild/output/src1270943608/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexXAtwwa86axt0amDKm2l3UTPxWZ13KbAJj5rLsjtTHMQMeta } from "/codebuild/output/src1270943608/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi3JqlS9NfVq3irAHI5YORr_BVyj9eMzcid4thYa4fEtUMeta } from "/codebuild/output/src1270943608/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit3ulEbcMUw8eDHnkpTCd9aGyGOlC1g_45Ky7EtxEmAw5KgMeta } from "/codebuild/output/src1270943608/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementb0cyPFnKR4hntQ6nfGVUzgx6ry7LEK9vRH_V2_9vxZYMeta } from "/codebuild/output/src1270943608/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexRl8sqPUA__45DW18O2t9W11SuwWli2yESqtZgiVFKyxC8Meta } from "/codebuild/output/src1270943608/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dGsHoAoDFxwj5svLfIMWlDfUn7I7ZbeXH4f5cPzrTCDMMeta } from "/codebuild/output/src1270943608/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmPqkP3Yhk10W36GWBNOrRMCQC0ysKCVbIdM17TT7T3Y0Meta } from "/codebuild/output/src1270943608/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexA4FXjmWWTg9iDvFx1yFIH4jnm0LuL3A1pajwrG6IsjgMeta } from "/codebuild/output/src1270943608/src/src/pages/card/create/index.vue?macro=true";
import { default as indexadzXTXkDKKqpzcwYXnvMElGs7g_458tJ7o8WbNVXiaRF8Meta } from "/codebuild/output/src1270943608/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm88Cw1P5tc8I63OQPKcwN4JQV7BakTKsnwSNZbsT5sDIMeta } from "/codebuild/output/src1270943608/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm4hJEJHk_45SLY4T8BgEnPlmQ3jjwOEMQQfCTD2_45GH4HYkMeta } from "/codebuild/output/src1270943608/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeIy_45_hwWk_UTHd0u0AeebIt7Kcat1oeA96083voIkikwMeta } from "/codebuild/output/src1270943608/src/src/pages/membership/complete.vue?macro=true";
import { default as registereEfHwDJIvmSIILLThRzJxijMY_CfrycS_hBZCDUdGi4Meta } from "/codebuild/output/src1270943608/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93LTk0Gk4DQBVTikENIoIHLd_45ueaxemLTA6gsvX6R2koYMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmLvtggZLFk9Z8KwhaVu4juFqLa70NipMLkwJy6VJo29wMeta } from "/codebuild/output/src1270943608/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93vt2zj5SxtcmlEBMjgzsLieB5RrFSaYRvaVnVwMzakbQMeta } from "/codebuild/output/src1270943608/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexUIR1xnx8wfcTcnQV9XkO87zcWBDe2TmkXrC1yha7fpAMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codetV6ip5bEd7DWswTL_tCNdS_o0hDO1B0Jm3mikgK6DcwMeta } from "/codebuild/output/src1270943608/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code43_454ir41bWC4orP_rkmHXRRX1kPEPA8urlvQ_4wN43UMeta } from "/codebuild/output/src1270943608/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeJa_45tYNtIeswmqnt0n_45nmmf9SEHUt1X_45zCnl3BFXNwPMMeta } from "/codebuild/output/src1270943608/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerDZUqyBbwIADOKY8aPyorKuQQaWmBoftppp2OUo_45OFEoMeta } from "/codebuild/output/src1270943608/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeBkUWKWz7yYKN_1uQDvH6IfQtjkFtEgTMdAgDJ08FSNgMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexDZGIFKrtJeW_YQguMIKYf9PE2NhpeiWjyd8_45XQCjMlwMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmxqGT9egNnMO9uwNcJDLCZqnYpjaYmELWI3KnsGC5K54Meta } from "/codebuild/output/src1270943608/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete27meTdCqf4e3EoXDRqtEIdadJUdo_457M0cDdP7lbYOogMeta } from "/codebuild/output/src1270943608/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexn_uNA_uqLO1Fi2msp4YWyRHu_459WUgM04wL1aGyiv6nIMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93OXqMTfkXUdxYfjJ_45PUVZhRkub6IGdSJrJQ4jv8eb_45t8Meta } from "/codebuild/output/src1270943608/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeXJEz1P3Er1SonBlmpBMbmLo1rQZOunM3e12ljPUyovQMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasp1CZR0PMsH7VX2oUp8xsOiPRElow_451b5DoOqps5qC3wMeta } from "/codebuild/output/src1270943608/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleWue_11sX2Ts3lvL_Z9gPa_45GxC9CM5_tzksJ5YO_45FLm4Meta } from "/codebuild/output/src1270943608/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailD2IVe2LDAGPj5mtRBhM5El87O8yoKUkQkFAsBpkAGdoMeta } from "/codebuild/output/src1270943608/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmdum8bObtma6nvSzzIqiOeUT9ZTFXGbd7TXKPbmurqvYMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentohfS1SKJvO38C0UbAaYOcsNZrtwcMZocX4vganZt2aIMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmWPlR_45Lvj8_aDe_45hZIzFAxv3DYu1s12uo2fLctEqEFq4Meta } from "/codebuild/output/src1270943608/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateov2NnB26Z4G2weW3NxmoLdPJUKYnub5gejBkVuaYLhAMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete4PqWn3ZWAxg_452g_WWg_45X7bSD5_9qCjgnzvttX7NDflcMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codexN5y3WiL9xiJotI4U0BFs_YOWy85yCvfLOF_45zxU5FeUMeta } from "/codebuild/output/src1270943608/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordEgw6dP44qdbrZpXBMaBBK6ipc82gLLu0x3ENGryocNMMeta } from "/codebuild/output/src1270943608/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasy_TyfFcf_45y_V5VOBtJYd8CcnzXcYveX6jDYgCn7o09kMeta } from "/codebuild/output/src1270943608/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register3aj_xyIehsz8AHsM9n6rqf9ji_45Cb7vRocdiPvWJfZUQMeta } from "/codebuild/output/src1270943608/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code7pWU5yEqArTYD4GxeN_yZWBJsTSLleiXQ_HmJS_Y0zAMeta } from "/codebuild/output/src1270943608/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index7sB2eYwfnEy6DMOnRDtyKJ0OdeY3esvJOSjAxttg_4518Meta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexMxEZ5BTtxVYHw77Kc8EJ6uF4PjO_DWnvFaDZMxZDhXkMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexjXiw7MYjXBfpEz_QdvpgVlmsFi6XfNoJ_L5lkvOv7QIMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index4ZwKhKIzu8G4_6VCI9GELzsGhuRvAaJc_dJscIagGBkMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateholzC7wtiKHFumSO6miAuZidxHIWMOo4oZFkV0kU5vAMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeOYapPulMFfKMt_45SghEvifavxEA3gfa2h7RpdAZvaktMMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm9xEnbM1tJci7NI0XEMT_TzbuehJYeMC1qCXoFOmk1FcMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexFO_45orMPCrm5XjwcwLdIskNY6Lct2tAAlWDzWEUTNdBQMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete3w6_dCY5C3gOaa0zRWPOT2z2qhu_NppPF7pNB07lXuIMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateSQt_QUz4KLHKTngF6J4Z2f_45bAOzoRlXNhRdkd7qqjzgMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexfA6Mztfdfi2SiJ89jaReZcvHtYhNj8JtzZM7OZN_XG0Meta } from "/codebuild/output/src1270943608/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index0wQQse1Gx1O0p8ALXN3xGbIVSvVO3Dq3CuGEGua0L9QMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completehBqoidZ2TAxoBGnpFkiQxCnGPtNjjliiFe_tPBfmwFAMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexm2cnGjbyskSBy1mEWBq7khw_LP_e_45Gm_7hnGlpUMcdEMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeo1mRSJ_45YdQUCghfukBTrrnj5DsObj7BwwdSiflBw2c4Meta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexj713x1GtKumGStmHdI7lxFI4_45ENwvd6uE_swKIeI2DcMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexEcZXM5JB0N04X3wlox0eKs_45iB_45zQQ844Yp4MWKwloMwMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexldA_45cCN3HZAJZdtbCVX4Owttum198L11ndziM4TCq4gMeta } from "/codebuild/output/src1270943608/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatezAvlLqyThnHafZA8QvFmwtHly6N4sbaqY_45i58dEH3JEMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmU1iSOqlYlA_45vZcI5GjqffOPOYRAY1_45109Khu4kAbDXgMeta } from "/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu5PkTmMp7FpAGgdbJ0ef4gHTnQIUzgqOBRZO1wauSqSYMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index_Qri7I9UT8XwvXZx5n_xFIwbqoe0J9Ta59nqpZEfSUkMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexNEwFUca9HO_kLCHqMFD_sxsBazHGXf_45GEd5CyddDdaUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index3ggf5JO2W2DY6fFmPKhfISxQApoojL6ZRDDQgpW8w7kMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexgOHDXmkILJAzA8Mks8Tf_COhr5z6mXneWn7dq7u4rtAMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexXAtwwa86axt0amDKm2l3UTPxWZ13KbAJj5rLsjtTHMQMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexA4FXjmWWTg9iDvFx1yFIH4jnm0LuL3A1pajwrG6IsjgMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm88Cw1P5tc8I63OQPKcwN4JQV7BakTKsnwSNZbsT5sDIMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm4hJEJHk_45SLY4T8BgEnPlmQ3jjwOEMQQfCTD2_45GH4HYkMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeIy_45_hwWk_UTHd0u0AeebIt7Kcat1oeA96083voIkikwMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registereEfHwDJIvmSIILLThRzJxijMY_CfrycS_hBZCDUdGi4Meta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmLvtggZLFk9Z8KwhaVu4juFqLa70NipMLkwJy6VJo29wMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codetV6ip5bEd7DWswTL_tCNdS_o0hDO1B0Jm3mikgK6DcwMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code43_454ir41bWC4orP_rkmHXRRX1kPEPA8urlvQ_4wN43UMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeJa_45tYNtIeswmqnt0n_45nmmf9SEHUt1X_45zCnl3BFXNwPMMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerDZUqyBbwIADOKY8aPyorKuQQaWmBoftppp2OUo_45OFEoMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmxqGT9egNnMO9uwNcJDLCZqnYpjaYmELWI3KnsGC5K54Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete27meTdCqf4e3EoXDRqtEIdadJUdo_457M0cDdP7lbYOogMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexn_uNA_uqLO1Fi2msp4YWyRHu_459WUgM04wL1aGyiv6nIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeXJEz1P3Er1SonBlmpBMbmLo1rQZOunM3e12ljPUyovQMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleWue_11sX2Ts3lvL_Z9gPa_45GxC9CM5_tzksJ5YO_45FLm4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailD2IVe2LDAGPj5mtRBhM5El87O8yoKUkQkFAsBpkAGdoMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmdum8bObtma6nvSzzIqiOeUT9ZTFXGbd7TXKPbmurqvYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentohfS1SKJvO38C0UbAaYOcsNZrtwcMZocX4vganZt2aIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmWPlR_45Lvj8_aDe_45hZIzFAxv3DYu1s12uo2fLctEqEFq4Meta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete4PqWn3ZWAxg_452g_WWg_45X7bSD5_9qCjgnzvttX7NDflcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codexN5y3WiL9xiJotI4U0BFs_YOWy85yCvfLOF_45zxU5FeUMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordEgw6dP44qdbrZpXBMaBBK6ipc82gLLu0x3ENGryocNMMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register3aj_xyIehsz8AHsM9n6rqf9ji_45Cb7vRocdiPvWJfZUQMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code7pWU5yEqArTYD4GxeN_yZWBJsTSLleiXQ_HmJS_Y0zAMeta || {},
    component: () => import("/codebuild/output/src1270943608/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1270943608/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]